import { axiosInstance } from "api/axios";
import useCustomQuery from "hooks/useCustomQuery";
import { IPIDeliverance } from "dto/PI/IPIDeliverance";
import { mockPIDeliverances } from "./mock/mockPIDeliverances";

/**
 * Rejestr „Doręczenia PI" — dane z integracji z Portalem Informacyjnym sądów
 * powszechnych. Pobierane z dedykowanego endpointu BE:
 *
 *   GET /pi/deliverances?Text=...
 *
 * Dopóki endpoint nie jest dostępny (środowisko dev / brak BE), serwis korzysta
 * z danych przykładowych (`mockPIDeliverances`) jako fallback po błędzie.
 */

const QUERY_KEY = "piDeliverances";

const getPIDeliverancesApi = async (
  searchText?: string,
): Promise<IPIDeliverance[]> =>
  (
    await axiosInstance.get<IPIDeliverance[]>("/pi/deliverances", {
      params: { Text: searchText?.trim() || undefined },
    })
  ).data;

const filterMock = (searchText?: string): IPIDeliverance[] => {
  const q = searchText?.trim().toLowerCase();
  if (!q) return mockPIDeliverances;
  return mockPIDeliverances.filter((d) =>
    [d.CaseSignature, d.Court, d.Department, d.DocumentType, d.Title, d.Judge, d.Client]
      .filter(Boolean)
      .some((v) => (v as string).toLowerCase().includes(q)),
  );
};

const piDeliverancesService = {
  useGetPIDeliverances: (searchText?: string) =>
    useCustomQuery<IPIDeliverance[]>(
      [QUERY_KEY, searchText ?? ""],
      async () => {
        try {
          const result = await getPIDeliverancesApi(searchText);
          // Endpoint może nie istnieć i zwrócić 200 z nie-tablicą (np. HTML SPA)
          // — wtedy także korzystamy z danych przykładowych.
          return Array.isArray(result) ? result : filterMock(searchText);
        } catch {
          // Brak/niedostępny endpoint PI — pokaż dane przykładowe.
          return filterMock(searchText);
        }
      },
      { retry: false },
    ),
};

export default piDeliverancesService;
